import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGUAGES } from "../i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "pss_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    return saved && translations[saved] ? saved : "pl";
  });

  const changeLang = useCallback((code) => {
    if (translations[code]) {
      setLang(code);
      localStorage.setItem(STORAGE_KEY, code);
    }
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
